import { lazy } from 'react';

export const PlayerReopenCustomerForm = lazy(
  () => import('./PlayerReopenCustomerForm'),
);
